import React from "react";
import avatarImg from "../assets/Avatar.png";

export type TabId =
  | "global-insights"
  | "variance-explorer"
  | "financial-intelligence"
  | "executive-summary"
  | "audit";

const TABS: { id: TabId; label: string; disabled?: boolean }[] = [
  { id: "global-insights",        label: "Global Insights" },
  { id: "variance-explorer",      label: "Variance Explorer" },
  // { id: "financial-intelligence", label: "Financial Intelligence" },
  { id: "executive-summary",      label: "Executive Summary" },
  { id: "audit",                  label: "Audit" },
];

interface TopNavProps {
  activeTab: TabId;
  onTabChange: (tab: TabId) => void;
  userName?: string;
  userInitials?: string;
  userDesignation?: string;
}

const TopNav: React.FC<TopNavProps> = ({
  activeTab,
  onTabChange,
  userName = "Sarah Jenkins",
  userInitials = "SJ",
  userDesignation = "Chief Financial Officer",
}) => {
  return (
    <nav className="top-nav">
      {/* Logo */}
      <div className="top-nav-logo">
        <div className="top-nav-logo-icon">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
            <rect x="0" y="0" width="6" height="6" rx="1.2" fill="white" />
            <rect x="8" y="0" width="6" height="6" rx="1.2" fill="white" fillOpacity="0.45" />
            <rect x="0" y="8" width="6" height="6" rx="1.2" fill="white" fillOpacity="0.45" />
            <rect x="8" y="8" width="6" height="6" rx="1.2" fill="white" />
          </svg>
        </div>
        <span className="top-nav-logo-text">FinanceCore</span>
      </div>

      {/* Tabs */}
      <div className="top-nav-tabs" role="tablist">
        {TABS.map((tab) => (
          <button
            key={tab.id}
            role="tab"
            aria-selected={activeTab === tab.id}
            className={[
              "top-nav-tab",
              activeTab === tab.id ? "top-nav-tab--active" : "",
              tab.disabled ? "top-nav-tab--disabled" : "",
            ]
              .filter(Boolean)
              .join(" ")}
            onClick={() => !tab.disabled && onTabChange(tab.id)}
            disabled={tab.disabled}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* User */}
      <div className="top-nav-user">
        <div className="top-nav-user-info">
          <span className="top-nav-username">{userName}</span>
          <span className="top-nav-designation">{userDesignation}</span>
        </div>
        <div className="top-nav-avatar-wrap">
          <img src={avatarImg} alt={userName} className="top-nav-avatar" />
          <span className="top-nav-online-dot" />
        </div>
      </div>
    </nav>
  );
};

export default TopNav;
